'use client'

import styles from './VideoInline.module.scss'
import { useEffect, useMemo, useState } from 'react'
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer'
import { createPlayerProps } from '@/elements/widgets/Video/utils'
import type { VideoPlayerProps } from '@/types/video'
import { PlayerInterface } from '@foundation-player/api'
import StructuredData from '@/elements/widgets/Video/StructuredData'
import { useIsPurMode } from '@/hooks/useIsPurMode'
import VideoLabel from '@/components/Video/VideoLabel'

const VideoInline = ({ item }: { item: any }) => {
  const [player, setPlayer] = useState<PlayerInterface | undefined>(undefined)

  const videoContext = item.items[0]

  const isPurMode = useIsPurMode()

  const [playerProps, setPlayerProps] = useState<VideoPlayerProps | undefined>(
    videoContext
      ? createPlayerProps({
          context: videoContext,
          autoplay: false,
          heartbeatStarttype: 0,
          isPurMode,
        })
      : undefined,
  )

  useEffect(() => {
    const handleSessionEnd = () => {
      if (item.items[0]) {
        setPlayerProps(
          createPlayerProps({
            context: item.items[0],
            autoplay: false,
            heartbeatStarttype: 1,
            isPurMode,
          }),
        )
      }
    }

    if (player) {
      player.state.onValueChange('sessionCompleted', ({ sessionCompleted }: { sessionCompleted: boolean }) => {
        if (sessionCompleted) handleSessionEnd()
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player])

  if (!(videoContext && playerProps)) return null

  const videoPlayer = useMemo(
    () => (
      <VideoPlayer
        props={createPlayerProps({
          context: videoContext,
          autoplay: false,
          heartbeatStarttype: 0,
          isPurMode,
        })}
        providePlayer={setPlayer}
      />
    ),
    [videoContext],
  )
  return (
    <>
      <StructuredData item={videoContext} />
      <div className={styles.wrapper} data-cy={`video-inline-${videoContext?.model?.id}`}>
        <div>{videoPlayer}</div>
        <div className={styles['text-container']} data-cy="text-container">
          <VideoLabel duration={videoContext?.model?.durationMillis} />
          <h2 className={styles.headline}>{videoContext?.model?.headline}</h2>
        </div>
      </div>
    </>
  )
}

export default VideoInline
